import { useQuery } from '@tanstack/react-query';
import { tiktokQueries, tiktok } from '@round/api';
import { Point } from '@round/whitelabel-ui';

const options = tiktokQueries.timeSeries.options.list;
const utils = tiktokQueries.timeSeries.utils.list;

const mapTimeSeriesToPoints = (t: tiktok.TiktokTimeSeries): Point => ({
    x: t.timestamp,
    y: t.value,
});

const sortTimeStamps = (a: string, b: string) => new Date(a).getTime() - new Date(b).getTime();

type Params = { audioId: number | null | undefined } & Pick<
    tiktok.TiktokTimeSeriesRequestParams,
    'start_date' | 'end_date'
>;

export default function useCreations({ audioId, start_date, end_date }: Params) {
    const result = useQuery({
        ...options({
            type: 'audio',
            ids: audioId ? [audioId] : [],
            fields: ['posts_daily_change', 'posts_daily_totals'],
            start_date: start_date,
            end_date: end_date,
        }),
        enabled: typeof audioId === 'number',
        select: (data) => {
            if (typeof audioId !== 'number') {
                return {
                    daily: [],
                    totals: [],
                };
            }

            const { posts_daily_change, posts_daily_totals } = data[audioId];
            return {
                daily: posts_daily_change.map(mapTimeSeriesToPoints).sort((a, b) => sortTimeStamps(a.x, b.x)),
                totals: posts_daily_totals.map(mapTimeSeriesToPoints).sort((a, b) => sortTimeStamps(a.x, b.x)),
            };
        },
    });

    return {
        result,
        helpers: utils,
    };
}
